'use client';

import { RouterLink } from '@/navigation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { icons } from '@peerless/ui-assets/icons';
import { useTranslations } from 'next-intl';

export function NotFoundLink() {
  const t = useTranslations('Error');
  return (
    <Button variant="text" color="secondary" component={RouterLink} href="/">
      <FontAwesomeIcon fixedWidth icon={icons.home} />
      &nbsp;{t('navigate-home')}
    </Button>
  );
}
